import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PeopleIcon from "@mui/icons-material/People";
import PortraitIcon from "@mui/icons-material/Portrait";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { Link } from "react-admin";
import { MenuItem, Theme, useMediaQuery } from "@mui/material";
import * as React from "react";
import PaymentsIcon from "@mui/icons-material/Payments";
import { AppBar, Button, useLogout } from "react-admin";
import { OpenTabsContext } from "../OpenTabsContext";
import ProfileIcon from "../unit/svgIcon/ProfileIcon";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { AppBarToolbar } from "./AppBarToolbar";
import HMUserMenu from "./HMUserMenu";
import { useNavigate } from "react-router";
const RightAdminMenu = () => {
  return <ProfileIcon size="20px" />;
};
const CustomUserMenu = () => {
  const navigate = useNavigate();
  const { openGlobalTabs, removeAllGLobalTab, removeGlobalTab } =
    React.useContext(OpenTabsContext);
  const handleLogout = async () => {
    const access_token = localStorage.getItem("access_token");
    const csrfToken = localStorage.getItem("csrfToken");

    try {
      const response = await fetch(import.meta.env.VITE_API_URL + "/logout", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${access_token}`,
          "X-CSRF-TOKEN": `${csrfToken}`,
          "X-XSRF-TOKEN": `${csrfToken}`,
        },
      });

      const data = await response.json();
      console.log("Logout response:", data);
    } catch (error) {
      console.error("Logout API error:", error);
    } finally {
      removeAllGLobalTab();

      const itemsToRemove = [
        "bankId",
        "user",
        "email",
        "username",
        "access_token",
        "bank",
        "bbaccess",
        "auth",
        "openTabs",
        "openGlobalTabs",
        "authrole",
        "product_counselors",
        "employer_proudcts",
        "all_experts",
        "division",
        "permissions",
        "mainpathname",
        "applicationMenuStats",
        "customerMenuStats",
        "loanMenuStats",
        "csrfToken", //reminder delete CSRF token
        "access_token_expiry",
      ];

      itemsToRemove.forEach((item) => {
        localStorage.removeItem(item);
      });

      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith("backUrl")) {
          localStorage.removeItem(key);
        }
      });
      window.location.href = "/login";
    }
  };
  const authrole = localStorage.getItem("authrole");
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];

  const bankId = localStorage.getItem("bankId");
  let adminURL = "";
  if (authrole == "bankadmin") {
    adminURL = `/banks/${bankId}`;
  } else if (authrole == "admin") {
    adminURL = `/banks/`;
  } else {
    adminURL = ``;
  }
  return (
    <HMUserMenu icon={<RightAdminMenu />}>
      <MenuItem
        id="menu-account"
        sx={{
          color: "gray",
          fontSize: "0.875rem",
          fontFamily: "Proxima Nova",
          width: "200px",
        }}
        component={Link}
        to="/profile"
      >
        <PortraitIcon sx={{ color: "gray", fontSize: "1.2rem", mr: 2 }} />
        Account
      </MenuItem>
      {permissions.includes("personal_refills") && (
        <MenuItem
          id="menu-account"
          sx={{
            color: "gray",
            fontSize: "0.875rem",
            fontFamily: "Proxima Nova",
            width: "200px",
          }}
          component={Link}
          to="/refill"
        >
          <PaymentsIcon sx={{ color: "gray", fontSize: "1.2rem", mr: 2 }} />
          Refill
        </MenuItem>
      )}

      {adminURL && (
        <MenuItem
          id="menu-institution"
          sx={{
            color: "gray",
            fontSize: "0.875rem",
            fontFamily: "Proxima Nova",
            width: "200px",
          }}
          component={Link}
          to={authrole == "bankadmin" ? `/banks/${bankId}` : `/banks/`}
        >
          <AccountBalanceIcon
            sx={{ color: "gray", fontSize: "1.2rem", mr: 2 }}
          />
          Admin
        </MenuItem>
      )}
      <MenuItem
        id="menu-logout"
        sx={{
          color: "gray",
          fontSize: "0.875rem",
          fontFamily: "Proxima Nova",
          width: "200px",
        }}
        onClick={() => {
          handleLogout();
        }}
      >
        <ExitToAppIcon sx={{ color: "gray", fontSize: "1.2rem", mr: 2 }} />
        Logout
      </MenuItem>
    </HMUserMenu>
  );
};
const CustomAppBar = () => {
  const isLargeEnough = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up("sm")
  );
  const CustomAppBarToolbar = () => {
    return <></>;
  };
  return (
    <AppBar
      color="inherit"
      toolbar={<AppBarToolbar />}
      userMenu={<CustomUserMenu />}
      alwaysOn={true}
    ></AppBar>
  );
};

export default CustomAppBar;
